import React from 'react';
import { connect } from 'react-redux';
import { fetchUsuarios, setFiltroUsuarios } from '../../actions/usuariosActions';
import FiltroUsuarios from '../../components/Usuarios/FiltroUsuarios';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from '../General/BigSpinner'
import UserListItem from './UserListItem';
import ReactPaginate from 'react-paginate';

class ListModeradores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nombreUsuario: "",
            numeroPagina: 1,
            showFilter: false
        };
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.buscarUsuarios();
    }

    buscarUsuarios = (isFromFilter) => {
        let filtro = this.props?.filtro;
        this.props.fetchUsuarios({
            idSeller: this.props.idSeller,
            numeroPagina: filtro?.numeroPagina,
            nombreUsuario: filtro?.nombreUsuario
        });
        if (isFromFilter) {
            this.setState({ numeroPagina: 1 });
        };
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        let filtro = this.props?.filtro;
        filtro.numeroPagina = selectedPage;
        this.props.setFiltroUsuarios(filtro);
        this.setState({ 
            numeroPagina: selectedPage 
        }, () => this.buscarUsuarios());
    };

    onUsuario = (id) => {
        this.props.history.push(`/Usuarios/Editar/${id}`);
    }

    goToUserNuevo = (dropdownSelect) => {
        this.props.history.push({
            pathname: "/Usuarios/NuevoUser",
            state: { dropdownSelect }
        });
    }


    render() {
        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-12 col-sm-6">
                        <h3 className="text-themecolor color-rojo-megatone">{this.props.userName}</h3>
                    </div>

                    <div className="button-group col-12 col-sm-6 text-end mt-2 mt-sm-0">
                        {this.props.userType.isAdminMod &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(2)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" />
                                Crear Proveedor
                            </button>
                        }

                        {(this.props.userType.isAdminMod || this.props.userType.isSellerAdmin) &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(0)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" />
                                {this.props.userType.isAdminMod ? "Crear Moderador" : "Crear Usuario"}
                            </button>
                        }

                        <BtnToggleFilter
                            show={this.state.showFilter}
                            handleShow={() => this.setState({ showFilter: !this.state.showFilter })}
                        />
                    </div>
                </div>

                <div hidden={!this.state.showFilter}>
                    <FiltroUsuarios
                        filtro={this.props.filtro}
                        fetchUsuarios={() => this.buscarUsuarios(true)}
                    />
                </div>

                {this.props.isLoading ? <BigSpinner /> :
                    <div>
                        {this.props?.usuarios && this.props.usuarios?.length > 0 ?
                            <ul className="list-group">
                                {this.props.usuarios.map((usuario, index) => {
                                    return (
                                        <a key={index} onClick={() => { this.onUsuario(usuario.idUsuario) }}>
                                            <UserListItem
                                                id={usuario.idUsuario}
                                                nombreUsuario={usuario.nombreUsuario}
                                                email={usuario.email}
                                            />
                                        </a>
                                    )
                                })
                                }
                            </ul>
                            :
                            <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                                No se encontraron usuarios
                            </h5>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.usuarios.cantidadTotal / 10}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.numeroPagina - 1}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    isLoading: state.usuarios.isLoading,
    userType: state.general.userType,
    userName: state.general.userName,
    idSeller: state.general.idSeller,
    usuarios: state.usuarios.usuarios,
    filtro: state.usuarios.filtro
});

export default connect(mapStateToProps, { fetchUsuarios, setFiltroUsuarios })(ListModeradores);